import { errorCode, errorMessage } from '@/shared/lib'

export const SCENARIO_CONFLICT = 'SCENARIO_CONFLICT'

// Коды бэкенда при заведении и правке сценария — словами и с действием.
// Имя уникально в пределах владельца; ревизия — оптимистичная блокировка.
const saveErrorTexts: Record<string, string> = {
  SCENARIO_NAME_TAKEN:
    'У этого владельца уже есть сценарий с таким именем — имя уникально в пределах владельца.',
  [SCENARIO_CONFLICT]:
    'Сценарий изменён параллельно — форма перечитала его, повтори правку поверх свежей ревизии.',
  SCENARIO_OWNER_REQUIRED:
    'Нужен владелец: без owner_account_id сценарий платформенный, а такие заводит только оператор.',
  SCENARIOS_FORBIDDEN:
    'Платформенный сценарий принадлежит оператору — приложению он только на чтение.',
}

export function scenarioSaveErrorMessage(error: unknown): string {
  return saveErrorTexts[errorCode(error)] ?? errorMessage(error)
}

/** 409 поверх устаревшего чтения: ревизия в базе ушла вперёд. */
export function isScenarioConflict(error: unknown): boolean {
  return errorCode(error) === SCENARIO_CONFLICT
}
